import { AppTableControls } from 'common/TableControls/TableControls';
import type { Room, Subject } from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import { SubjectsCell } from '../../SubjectsCell';

const SUBJECTS_CELL_MAX_WIDTH = '90rem';

export const getRoomsTableColumns = (
  edit: (id: number) => void,
  remove: (id: number) => void,
  copy: (id: number) => void,
): AppTableColumn<Room>[] => {
  const columns: AppTableColumn<Room>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '10rem',
    },
    {
      key: 'number',
      title: 'Номер аудитории',
      dataIndex: ['number'],
    },
    {
      key: 'name',
      title: 'Наименование аудитории',
      dataIndex: ['name'],
    },
    {
      key: 'subjects',
      title: 'Список предметов, допустимых для аудитории',
      dataIndex: ['subjects'],
      sorter: false,
      maxWidth: SUBJECTS_CELL_MAX_WIDTH,
      render: (value: Subject[]) => (
        <SubjectsCell subjects={value} maxWidth={SUBJECTS_CELL_MAX_WIDTH} />
      ),
    },
    {
      key: 'controls',
      title: '',
      dataIndex: [],
      maxWidth: '10rem',
      render: (value: any, record: Room) => {
        const editRoom = () => edit(record.id!);
        const removeRoom = () => remove(record.id!);
        const copyRoom = () => copy(record.id!);

        return <AppTableControls edit={editRoom} remove={removeRoom} copy={copyRoom} />;
      },
    },
  ];

  return columns;
};
